mutation TripBreakdownExportFilter($input: TripBreakdownExportFilterInput!) {
  tripBreakdownExportFilter(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
